"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.branch.list': 'Rami',
    'route.branch.create': 'Aggiungi Ramo',
    'route.branch.edit': 'Modifica Ramo',
};
